import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class UserRulesService {

  showUserRules = new EventEmitter<boolean>();

  constructor() { }

  showUserRulesPopup(show : boolean) {
    this.showUserRules.emit(show);
  }

}
